@if (address) {
  <pdq-resource-item
    [color]="clickable ? 'white' : 'gray'"
    [clickable]="clickable"
    (onClick)="handleLocationClick($event)"
    icon="navigation">
    <div class="location-content">
      <div class="location-title">
        <p class="location-name">{{ addressTitle }}</p>
        @if (isDefault) {
          <pdq-tag value="Default"></pdq-tag>
        }
      </div>
      <div class="location-description">
        <p>{{ addressDescription }}</p>
        @if (address?.phone) {
          <p>{{ address.phone }}</p>
        }
      </div>
    </div>
  </pdq-resource-item>
}
